import { render, staticRenderFns } from "./AnnotationDetailsContainer.vue?vue&type=template&id=6df43644&scoped=true"
import script from "./AnnotationDetailsContainer.vue?vue&type=script&lang=js"
export * from "./AnnotationDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./AnnotationDetailsContainer.vue?vue&type=style&index=0&id=6df43644&prod&scoped=true&lang=scss"
import style1 from "./AnnotationDetailsContainer.vue?vue&type=style&index=1&id=6df43644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df43644",
  null
  
)

export default component.exports